import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router";
/**
 * Custom hook to manage user authentication status.
 * It checks for the presence and validity of the authentication token.
 * If the token is missing or expired, it redirects the user to the login page.
 * @return {Object} An object containing the authentication token.
 */

export const useUserAuthenticated = () => {
  const [token, setToken] = useState(Cookies.get("tkn"));
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!token || token === "") {
      sessionStorage.setItem(
        "redirectAfterAuth",
        window.location.pathname + window.location.search,
      );
      navigate("/entrar?refresh=true");
      return;
    }

    try {
      const info = jwtDecode(token);
      const expired = info.exp * 1000 < new Date().valueOf();

      if (expired) {
        sessionStorage.setItem(
          "redirectAfterAuth",
          window.location.pathname + window.location.search,
        );
        navigate("/entrar?refresh=true");
        return;
      }

      setUserId(info.userId);
      setToken(token);
    } catch (err) {
      console.error("Invalid token", err);
      sessionStorage.setItem(
        "redirectAfterAuth",
        window.location.pathname + window.location.search,
      );
      navigate("/entrar?refresh=true");
    }
  }, []);

  return { token, userId };
};
